import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { trpc } from '../../utils/trpc'
import type { Cycle } from './types'

export const useCycleFromParams = (): Cycle | undefined => {
	const { cycleId } = useParams<{ cycleId: string }>()
	const { data: cycle } = useQuery({
		...trpc.admin.cycles.getById.queryOptions({
			id: cycleId as string,
		}),
		enabled: !!cycleId,
	})

	return cycle
}
